import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import BarcodeIcon from '../../../../../../icons/BarcodeIcon';
import DesignEditorPrimaryControlButton from '../../../../../DesignEditor/components/DesignEditorControls/components/DesignEditorPrimaryControlButton';

const propTypes = {
  className: PropTypes.string,
  active: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

const CardDesignerBarCodeControlsButton = ({ className, active, onClick }) => {
  const classes = classNames({
    [className]: !!className,
  });

  return (
    <DesignEditorPrimaryControlButton
      className={classes}
      active={active}
      icon={<BarcodeIcon className="design-editor-barcode" />}
      title="Barcode"
      onClick={onClick}
    />
  );
};

CardDesignerBarCodeControlsButton.propTypes = propTypes;

export default CardDesignerBarCodeControlsButton;
